import VueBarcodeScanner from 'indy-vue-barcode-scanner'

const VueBarcodeScannerAdaptor = {
  install (app) {
    VueBarcodeScanner.install({
      prototype: app.config.globalProperties
    }, {
      // Options
      // https://www.npmjs.com/package/vue-barcode-scanner
      sensitivity: 200, // default is 100
      requiredAttr: true, // default is false
      controlSequenceKeys: null, // default is null
      callbackAfterTimeout: true // default is
    })
  }
}

export default async ({ app }) => {
  // inject vue barcode scanner
  app.use(VueBarcodeScannerAdaptor)
}
